import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Client } from '../../2_domain/client/client';
import ITestRepository from '../../2_domain/test/iTestRepository';
import { TestSummary } from '../../2_domain/test/test';
import Get from '../../lib/di/get';
import promiseResolver from '../../lib/util/promiseResolver';
const emptyPageResult: Page = {
  totalElements: 0,
  pageNumber: 0,
};

const emptyPagination: Pagination = {
  isAscending: false,
  pageNumber: 0,
  pageSize: 20,
};

const useOrderHistoryController = (client: Client) => {
  const testRepo = Get.find<ITestRepository>('ITestRepository');
  const navigate = useNavigate();

  const [pageResult, setPageResult] = useState<Page>(emptyPageResult);
  const [pagination, setPagination] = useState<Pagination>(emptyPagination);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [tests, setTests] = useState<TestSummary[]>([]);

  const setPageNumber = (newPageNumber: number) => {
    setPagination((prev) => {
      return { ...prev, pageNumber: newPageNumber };
    });
  };

  const setPageSize = (newPageSize: number) => {
    setPagination((prev) => {
      return { ...prev, pageSize: newPageSize };
    });
  };

  const setSortFilter = (sortFiler: SortFilter) => {
    setPagination((prev) => {
      return { ...prev, isAscending: sortFiler === 'Oldest' };
    });
  };

  const onClickRedirectToNewOrder = () => {
    navigate('../../test/order', { state: { client } });
  };

  const onClickRedirectToOrderId = (id: number) => {
    navigate(`../../test/${id}`);
  };

  useEffect(() => {
    promiseResolver({
      promise: testRepo.getTestByPatientID(client.id, pagination),
      successCallback: (data) => {
        setPageResult(data.page);
        setTests(data.list);
      },
      isLoadingCallback: setIsLoading,
      errorCallback: (err) => {
        console.log('clientOrderHistoryContoller', err);
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination]);

  return {
    isLoading,
    pageResult,
    pagination,
    setSortFilter,
    setPageNumber,
    setPageSize,
    tests,
    onClickRedirectToNewOrder,
    onClickRedirectToOrderId,
  };
};

export default useOrderHistoryController;
